import { LegEvent } from '../../types/strategy-entities';

export interface LegEventStateByStrategyId {
  loading: boolean;
  pending: boolean;
  loaded: boolean;
  error?: string;
  legEvents: LegEvent[];
}

export const initialLegEventStateByLegId: LegEventStateByStrategyId = {
  loading: false,
  pending: false,
  loaded: false,
  error: undefined,
  legEvents: []
};

export interface LegEventState {
  [strategyId: string]: LegEventStateByStrategyId;
}

export const initialLegEventState: LegEventState = {};
